import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M8 14.667A6.667 6.667 0 118 1.334a6.667 6.667 0 010 13.333zm0-1.334A5.333 5.333 0 108 2.667a5.333 5.333 0 000 10.666zm3.26-7.651l-5.578 5.579a4.028 4.028 0 01-.943-.943l5.579-5.579c.364.26.683.579.943.943z"
      ></path>
    </svg>
  )
}

export default Icon
